/**
 * Thư viện file rập — admin quản lý, staff xem + tải về (backend: app/api/patterns.py).
 */

import apiClient, { extractData } from '../api-client';

export const patternApi = {
  listCategories() {
    return apiClient.get('/patterns/categories').then(extractData);
  },
  createCategory(data) {
    return apiClient.post('/patterns/categories', data).then(extractData);
  },
  updateCategory(categoryId, data) {
    return apiClient.put(`/patterns/categories/${categoryId}`, data).then(extractData);
  },
  deleteCategory(categoryId) {
    return apiClient.delete(`/patterns/categories/${categoryId}`).then(extractData);
  },

  /** @param {{page?: number, size?: number, search?: string, category_id?: number}} params */
  list(params) {
    return apiClient.get('/patterns', { params }).then(extractData);
  },
  create(data) {
    return apiClient.post('/patterns', data).then(extractData);
  },
  update(patternId, data) {
    return apiClient.put(`/patterns/${patternId}`, data).then(extractData);
  },
  delete(patternId) {
    return apiClient.delete(`/patterns/${patternId}`).then(extractData);
  },

  /**
   * Upload nhiều file một lượt. File rập tới 100MB nên bỏ timeout 30s mặc định.
   * @param {number} patternId
   * @param {File[]} files
   * @param {(percent: number) => void} [onProgress]
   */
  uploadFiles(patternId, files, onProgress) {
    const formData = new FormData();
    files.forEach((f) => formData.append('files', f));
    return apiClient.post(`/patterns/${patternId}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    }).then(extractData);
  },
  /**
   * Link tải ZIP theo bộ lọc đang áp (không nhóm = tất cả). Trả {url, pattern_count,
   * file_count}; mở `url` bằng trình duyệt để tải native — gói có thể vài GB nên
   * không tải qua blob. 404 = không có file nào.
   * @param {{category_id?: number|null, search?: string|null}} filter
   */
  createDownloadLink(filter) {
    return apiClient.post('/patterns/download-link', filter).then(extractData);
  },
  deleteFile(patternId, filename) {
    return apiClient
      .delete(`/patterns/${patternId}/files/${encodeURIComponent(filename)}`)
      .then(extractData);
  },
};
